import { render, staticRenderFns } from "./ElementPengakhiran.vue?vue&type=template&id=08c9226c&"
import script from "./ElementPengakhiran.vue?vue&type=script&lang=js&"
export * from "./ElementPengakhiran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports